import React from 'react'
import Tooltip from './Tooltip'

export default ({ status, children, className, useBareClass, ...props }) => (
  <div className={`${useBareClass || 'fs18-sm d-sm-ib'} ${className || ''}`}>
    <Tooltip {...props} content={children} placement='right'>
      { status=='ineligible' || status=='inactive' || status=='unavailable' ?
       <i className={`icon-access-status-warning status-${status}`} /> :       
      status=='active' || status=='inprogress' ? 
        <i className={`icon-access-status-good status-${status}`} /> : 
      <i className='icon-access-status-warning inactive' /> 
      }              
    </Tooltip>
  </div>
)



// WEBPACK FOOTER //
// ./client/src/components/AccessStatusIndicator.js